import { Pipe, PipeTransform } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

@Pipe({
  name: "getimage",
})
export class GetImagePipe implements PipeTransform {
  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {}

  transform(url: string) {
    return new Observable<SafeResourceUrl>((observer) => {
      observer.next(
        "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
      );

      this.http
        .get("/static/loading.gif", { responseType: "blob" })
        .subscribe((response) => {
          const reader = new FileReader();
          reader.readAsDataURL(response);
          reader.onloadend = () => {
            observer.next(
              this.sanitizer.bypassSecurityTrustResourceUrl(
                <string>reader.result
              )
            );
            this.http
              .get(url, { responseType: "blob" })
              .subscribe((response) => {
                const reader = new FileReader();
                reader.readAsDataURL(response);
                reader.onloadend = () => {
                  observer.next(
                    this.sanitizer.bypassSecurityTrustResourceUrl(
                      <string>reader.result
                    )
                  );
                };
              });
          };
        });

      return { unsubscribe() {} };
    });
  }
}



// WEBPACK FOOTER //
// /agir/src/app/pipes/getimage.pipe.ts